import api from "../config";
import URLS from "../../constants/urls";
export const _getLayersBySiteID = async (siteId, pageNumber, pageSize) => {
    const response = await api.get(`${URLS.LAYER}/${siteId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.data;
};
export const _createLayerBySiteID = async (siteId, floorId, name) => {
    const response = await api.post(`${URLS.LAYER}/create`, {
        siteId,
        floorId,
        name,
    });
    return response.data;
};
export const _updateLayerBySiteID = async (siteId, layerId, name) => {
    const response = await api.put(`${URLS.LAYER}/${siteId}/${layerId}?name=${name}`);
    return response.data;
};
export const _deleteLayerBySiteID = async (siteId, layerId) => {
    const response = await api.delete(`${URLS.LAYER}/${siteId}/${layerId}`);
    return response.data;
};
